import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAdminQuestions } from "@/services/admin/adminApi";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const statusVariant: Record<string, "secondary" | "outline" | "default" | "destructive"> = {
  draft: "secondary",
  pending_review: "outline",
  live: "default",
  archived: "destructive",
};

const Questions = () => {
  const [statusFilter, setStatusFilter] = useState<string>("all");

  const { data: questions = [], isLoading } = useQuery({
    queryKey: ["admin-questions", statusFilter],
    queryFn: () =>
      getAdminQuestions(statusFilter === "all" ? undefined : statusFilter),
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Questions</h1>
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-48">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="pending_review">Pending review</SelectItem>
            <SelectItem value="live">Live</SelectItem>
            <SelectItem value="draft">Draft</SelectItem>
            <SelectItem value="archived">Archived</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {isLoading && <p className="text-gray-500">Loading...</p>}

      <div className="space-y-4">
        {questions.map((q) => (
          <div key={q.id} className="bg-white border rounded-lg p-4 space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900">
                  {q.persona_name.replace(/_/g, ' ')}
                </span>
                <Badge variant={statusVariant[q.status] ?? "outline"}>
                  {q.status}
                </Badge>
              </div>
              <span className="text-sm text-gray-500">{q.date}</span>
            </div>
            <p className="text-gray-800">
              {q.refined_question ?? q.raw_question}
            </p>
            {q.refined_question && q.raw_question !== q.refined_question && (
              <p className="text-sm text-gray-400 italic">
                Raw: {q.raw_question}
              </p>
            )}
          </div>
        ))}
        {!isLoading && questions.length === 0 && (
          <p className="text-gray-500">No questions found.</p>
        )}
      </div>
    </div>
  );
};

export default Questions;
